import getScenarioStore from '../store/getScenarioStore';
import { SearchScenarioId } from 'owa-search-next-common';
import { mutatorAction } from 'satcheljs';

/**
 * Set value in store to make suggestions callout clickable after current
 * render is complete. This will ensure that a click doesn't accidentally
 * happen on the first suggestion in the suggestions dropdown.
 */
export default mutatorAction('onSuggestionsCalloutPositioned', (scenarioId: SearchScenarioId) => {
    getScenarioStore(scenarioId).isSuggestionsCalloutClickable = true;
});
